"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var React = _interopRequireWildcard(require("react"));

var _form = _interopRequireDefault(require("@alifd/next/lib/form"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var Item = _form["default"].Item;
var PropsCtx = React.createContext();

var WrappedForm = function WrappedForm(props) {
  return React.createElement(PropsCtx.Provider, {
    value: props
  }, React.createElement(_form["default"], props));
};

var WrappedItem = function WrappedItem(props) {
  return React.createElement(PropsCtx.Consumer, null, function (formProps) {
    // fusion默认label靠右对齐，wind希望默认靠左对齐
    var labelTextAlign = function () {
      // Item有可能不用在Form中
      if ((0, _typeof2["default"])(formProps) !== 'object') return 'left';
      if (formProps.labelTextAlign === 'right') return 'right';
      return 'left';
    }();

    return React.createElement(Item, (0, _extends2["default"])({
      labelTextAlign: labelTextAlign
    }, props));
  });
};

(0, _hoistNonReactStatics["default"])(WrappedForm, _form["default"]);
(0, _hoistNonReactStatics["default"])(WrappedItem, Item);
WrappedForm.Item = WrappedItem;
var _default = WrappedForm;
exports["default"] = _default;